import { BaseModel } from '../BaseModel/BaseModel';
import { BaseFragmentEntity, RawBaseFragment } from './Types';
import { ItemTypeEntity, RawItemType } from '../ItemType/Types';
import {ItemTypeModel} from "../ItemType/ItemTypes";

export class BaseFragmentModel
    extends BaseModel<RawBaseFragment, BaseFragmentEntity>
    implements BaseFragmentEntity
{
    id: number = 0;
    title: string = '';
    itemTypes?: ItemTypeEntity[] = [];

    constructor(fragment?: RawBaseFragment) {
        super();
        if (fragment) {
            this.initialize(fragment);
        }
    }

    initialize(fragment: RawBaseFragment) {
        this.id = fragment.id;
        this.title = fragment.title;
        this.itemTypes = fragment.item_types?.length
            ? fragment.item_types.map(item => new ItemTypeModel(item))
            : [];
    }

    parse(): RawBaseFragment {
        return {
            id: this.id,
            title: this.title,
            ...(this.itemTypes && {
                item_types: this.itemTypes.map(item => item.parse()),
            }),
        };
    }
}
